import * as React from 'react';
import { CmicContext } from '../../context/CmicContext';
import { ActionContext } from '../../context/ActionContext';
import { styled, alpha } from '@mui/material/styles';
import { RiSave2Fill } from 'react-icons/ri';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { THEME_ID, baseFontFamilyStyle } from '../../shared/styles';
import { Toggle } from '@fluentui/react';
import { COLORS } from '../../utility/tasks/colors';
import { Stack } from '@fluentui/react';
import { Divider } from '@mui/material';
import { handleTHEMECLR } from '../../components/BorderImage';
import { isBGClrDark } from '../../utility/UtilityFunctions';

export default function CustomizedMenus({ onChangeEmailAutoFill, handleCreateNewPMItem }) {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const { currentOfficeTheme } = React.useContext(CmicContext);
	const { autoFillMailToggle } = React.useContext(ActionContext);

	const open = Boolean(anchorEl);
	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleSaveAsDraft = () => {
		handleCreateNewPMItem(true);
	};

	const StyledMenu = styled(props => (
		<Menu
			elevation={0}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			{...props}
		/>
	))(({ theme }) => ({
		'& .MuiPaper-root': {
			borderRadius: 2,
			marginTop: theme.spacing(1),
			minWidth: 180,
			backgroundColor: currentOfficeTheme.bodyBackgroundColor,
			color: currentOfficeTheme.bodyForegroundColor,
			boxShadow: `${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 1px 0.1px, ${COLORS.BG_GREY_DARK} 0px 0px 5px 0.1px`,
			'& .MuiMenu-list': {
				padding: '4px 0',
			},
			'& .MuiMenuItem-root:hover': {
				backgroundColor:
					currentOfficeTheme.themeId === THEME_ID.BLACK || currentOfficeTheme.themeId === THEME_ID.DARK_GREY
						? '#383838'
						: '#e6f2fa',
			},
			'& .MuiMenuItem-root': {
				'& .MuiSvgIcon-root': {
					fontSize: 18,
					color: currentOfficeTheme.bodyForegroundColor,
					marginRight: theme.spacing(1.5),
				},
				'&:active': {
					backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
				},
			},
		},
	}));

	const textStyle = {
		color: currentOfficeTheme.bodyForegroundColor,
		fontFamily: baseFontFamilyStyle,
		margin: '0.2rem',
		fontWeight: '400',
		fontSize: '13px',
		marginRight: '15px',
		cursor: 'pointer',
	};

	const toggleStyle = {
		height: '1.1rem',
		width: '1.8rem',
		margin: '0 0.2rem',
	};

	return (
		<Stack
			className={handleTHEMECLR(currentOfficeTheme)}
			onClick={open ? handleClose : handleClick}
			style={{
				display: 'flex',
				padding: '1px 8px',
				alignItems: 'center',
				justifyContent: 'center',
				cursor: 'pointer',
				marginLeft: '5px',
				border:
					currentOfficeTheme.themeId === THEME_ID.BLACK
						? `0.8px solid ${currentOfficeTheme.bodyForegroundColor}`
						: '1px solid rgba(174, 180, 189, 1)',
			}}
		>
			<h1
				id="demo-customized-button"
				aria-controls={open ? 'demo-customized-menu' : undefined}
				aria-haspopup="true"
				aria-expanded={open ? 'true' : undefined}
				variant="contained"
				style={{
					fontSize: '20px',
					color: isBGClrDark() ? COLORS.OUTLOOK_LIGHT_BLUE : COLORS.OUTLOOK_DARK_BLUE,
					margin: '0 5px',
				}}
			>
				&#8942;
			</h1>
			<StyledMenu
				id="demo-customized-menu"
				MenuListProps={{
					'aria-labelledby': 'demo-customized-button',
				}}
				style={{ cursor: 'pointer' }}
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
			>
				<MenuItem disableRipple style={{ cursor: 'pointer' }} onClick={handleSaveAsDraft}>
					<RiSave2Fill style={{ color: '#aeb4bd', height: '30px', width: '30px' }} />
					<label style={textStyle}>Save as Draft</label>
				</MenuItem>
				<Divider style={{ backgroundColor: 'rgb(128,128,128, 0.4)', margin: '0 5px', opacity: 0.6 }} />
				<MenuItem
					disableRipple
					style={{ alignItems: 'baseline', cursor: 'pointer' }}
					onClick={onChangeEmailAutoFill}
				>
					<Toggle inlineLabel style={toggleStyle} checked={autoFillMailToggle} />
					<label style={textStyle}> Autofill from Email</label>
				</MenuItem>
			</StyledMenu>
		</Stack>
	);
}
